import { render, staticRenderFns } from "./ChangelogItem.vue?vue&type=template&id=283a6710"
import script from "./ChangelogItem.vue?vue&type=script&lang=js"
export * from "./ChangelogItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports